<!-- 
程式：CarInsuranceUnRenewedDataTable.vue
功能：車險未續保名單表格
作者：i9400538 陳博承
完成：2020-04-29
-->
<template>
  <section class="newTable">
    <table
      class="table datatable table-striped area-list-datatable"
      id="CarInsuranceUnRenewedDataTable"
    >
      <thead>
        <tr>
          <th width="120">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget === `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                :disabled="true"
                v-model="checkAll"
              >
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'ceisdnm' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('ceisdnm')"
          >姓名</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'ceisdno' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('ceisdno')"
          >身分證</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'cartype' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('cartype')"
          >保單種類</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'lic_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('lic_no')"
          >車牌號碼</th>
          <th
            width="230"
            :class="'sorting ' + (order.fieldName === 'celpsdt' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('celpsdt')"
          >投保終期</th>
        </tr>
      </thead>
      <tbody @scroll="scrollmethod" class="block-height" :style="{height: height + 'px'}">
        <tr
          v-for="(d, did) in tableDataBackup"
          :key="`CarInsuranceUnRenewedDataTable-table-td-${did}`"
        >
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget === `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`CarInsuranceUnRenewedDataTable-check-${did}`"
                  :value="d.ceisdno"
                  v-model="selection"
                  :disabled="true"
                  @change="$emit('update', selection)"
                >
                <label :for="`CarInsuranceUnRenewedDataTable-check-${did}`"></label>
              </div>

              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <avatar :gender="Number(d.customer_sex)" :size="20"/>
                </span>
              </span>
            </div>
          </td>
          <td width="*">
            <template v-if="d.is_exist">
              <a
                class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.ceisdno)"
              >{{d.ceisdnm}}</a>
            </template>
            <template v-else>{{d.ceisdnm}}</template>
          </td>
          <td width="*">{{d.ceisdno || `— —`}}</td>
          <td width="*">{{d.cartype || `— —`}}</td>
          <td width="*">{{d.lic_no || `— —`}}</td>
          <td width="*">{{d.celpsdt | dateFormat}}</td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="6" class="text-center pt-3 pb-5">
            <h3>無車險未續保名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "CarInsuranceUnRenewedDataTable",
  mixins: [commonMixin],
  components: { Level, Avatar },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth
    };
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target === "clickAll" || target === "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    scrollmethod(e) {
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID) {
      this.updateCustID(custID);
      localStorage.CustID = custID;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.ceisdno;
      });
    }
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
